export default __webpack_public_path__ + "static/media/how-5.65806e30.png";